// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yq1nE","question":"styles_question__2kF1t","inputVisibleButton":"styles_inputVisibleButton__3LRIK","note":"styles_note__3uFkS"};